import { useEffect, useRef, useState } from "react";

const PHASE_DURATION_MS = 10000;
const PHASES = [
  { label: "Searching for signal",            sub: "Initializing observation session" },
  { label: "Locating signals closest to you", sub: "Resolving nearest asset in pool" },
  { label: "Signal acquired",                 sub: "Secure channel established" },
];

export const LoadingSequence = ({ onComplete, sessionId }) => {
  const [phase, setPhase] = useState(0);
  const [elapsedMs, setElapsedMs] = useState(0);
  const completedRef = useRef(false);

  useEffect(() => {
    const startAt = Date.now();
    const tick = setInterval(() => {
      setElapsedMs((Date.now() - startAt) % PHASE_DURATION_MS);
    }, 200);
    const t1 = setTimeout(() => { setPhase(1); setElapsedMs(0); }, PHASE_DURATION_MS);
    const t2 = setTimeout(() => { setPhase(2); setElapsedMs(0); }, PHASE_DURATION_MS * 2);
    const t3 = setTimeout(() => {
      if (!completedRef.current) { completedRef.current = true; onComplete(); }
    }, PHASE_DURATION_MS * 2 + 1200);
    return () => {
      clearInterval(tick);
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
    };
  }, [onComplete]);

  const line = PHASES[phase];
  const phaseFraction = phase === 2 ? 1 : Math.min(elapsedMs / PHASE_DURATION_MS, 1);
  const overallPct = ((phase + phaseFraction) / 3) * 100;

  return (
    <div className="loader" data-testid="loading-sequence">
      <div className="loader-frame">
        <div className="loader-brand">
          <span className="loader-brand-mark" />
          <span className="loader-brand-name">TRACKER</span>
          <span className="loader-brand-sep">/</span>
          <span className="loader-brand-sub">Observation Client</span>
        </div>

        <div className="loader-stage">
          <div className="loader-label" data-testid={`loading-phase-${phase}`}>
            {line.label}
          </div>
          <div className="loader-sub">{line.sub}</div>

          <div className="loader-bar">
            <div className="loader-bar-fill" style={{ width: `${overallPct}%` }} />
          </div>

          <div className="loader-dots">
            {PHASES.map((_, i) => (
              <span
                key={i}
                className={`loader-dot ${i < phase ? "done" : i === phase ? "active" : ""}`}
              />
            ))}
          </div>
        </div>

        <div className="loader-meta">
          <span>SESSION {sessionId}</span>
          <span className="loader-meta-dot" />
          <span>READ-ONLY</span>
        </div>
      </div>
    </div>
  );
};
